import gql from 'graphql-tag';

import { InfiniteList } from 'src/app/models/graphql';
import { VideoCard } from 'src/app/models/video';

export interface Playlist {
  id: string;
  name: string;
}

interface VideoInfiniteList extends Omit<InfiniteList, 'items'> {
  items: PlaylistVideo[];
}

export interface PlaylistWithVideo extends Playlist {
  videos: VideoInfiniteList;
}

export interface PlaylistVideo extends VideoCard {
  description: string;
}

export const GRAPHQL_CREATE_PLAYLIST_MUTATION = gql`
  mutation CreateNewPlaylist($name: String!) {
    createPlaylist(name: $name) {
      id
      name
    }
  }
`;

export const GRAPHQL_ADD_TO_PLAYLIST_MUTATION = gql`
mutation AddToPlaylist($playlistId: ID!, $videoId: ID!) {
  addVideoToPlaylist(playlistId: $playlistId, videoId: $videoId) {
    id
    inPlaylists {
      id
      name
    }
  }
}
`;

export const GRAPHQL_DELETE_PLAYLIST_MUTATION = gql`
  mutation DeleteNewPlaylist($id: ID!) {
    deletePlaylist(id: $id) {
      id
      name
    }
  }
`;

export const GRAPHQL_RENAME_PLAYLIST_MUTATION = gql`
  mutation RenameNewPlaylist($id: ID!, $name: String!) {
    renamePlaylist(id: $id, name: $name) {
      id
      name
    }
  }
`;

export const GRAPHQL_REMOVE_FROM_PLAYLIST_MUTATION = gql`
mutation RemoveFromPlaylist($playlistId: ID!, $videoId: ID!) {
  removeVideoFromPlaylist(playlistId: $playlistId, videoId: $videoId) {
    id
    inPlaylists {
      id
      name
    }
  }
}
`;
